import { Modal } from 'bootstrap';
import { AdminEvent } from 'static/classes/Event';
import { setDataAndShowDetailsModal } from 'static/components/details-modal/details-modal';

export function AllPastEventsViewModel(data){
    var self = this;
    self.type = "AllPastEventsViewModel";

    self.rootvm = data.rootvm;

    self.initialized = ko.observable(false);
    self.initialize = function(){

       // console.log('initing all past_events vm');

        if (!self.initialized()){
            self.lookup_past_events();
        }

        if (self.offset() == undefined){
            self.offset(0);
        }
        if (self.limit() == undefined){
            self.limit(80);
        }
    };

    self.total_count = ko.observable();
    self.filtered_count = ko.observable();
    self.offset = ko.observable();
    self.limit = ko.observable();

    self.last_week_count = ko.observable(0);

    self.past_events = ko.observableArray([]);

    self.selected_event_info = ko.observable(new AdminEvent({}));
    self.set_selected_event_info = function (scevent, modalId) {
        const modal = document.getElementById(modalId);
        scevent.get_artist_bank_details().then(
            self.selected_event_info(scevent),
            Modal.getOrCreateInstance(modal).show())
    }

    self.set_selected_data = function(scevent, tabId) {
        setDataAndShowDetailsModal(scevent, tabId);
    }

    self.error = ko.observable();
    self.search_name = ko.observable();
    self.to_be_paid_out_only = ko.observable(false);
    // Show concerts with an unpaid partial payout (FP/CP), ignoring the
    // past-concert-date restriction. Applied on Search click.
    self.partial_payout_only = ko.observable(false);

    self.search_name_click = function(){
        self.offset(0);
        console.log('searching with ', self.search_name());
        self.lookup_past_events();
        return false;
    }
    self.search_feedback = ko.observable();
    self.search_feedback_lang = ko.observable('german');

    self.search_feedback_click = function(){
        self.offset(0);
        console.log('searching with ', self.search_feedback());
        self.lookup_past_events();
        return false;
    }


    self.lookup_past_events = function(){
        self.rootvm.is_busy(true);
        return $.ajax({

            url: self.rootvm.web_host + '/api/admin/past-events',
            type: 'GET',
            data:{
                limit: self.limit(),
                offset: self.offset(),
                search_name: self.search_name(),
                search_feedback: self.search_feedback(),
                search_feedback_lang: self.search_feedback_lang(),
                to_be_paid_out_only: self.to_be_paid_out_only(),
                partial_payout_only: self.partial_payout_only()
            },

            contentType: "application/json; charset=utf-8",

            success: function (data) {

                self.past_events(ko.utils.arrayMap( data.events || [],
                    function(x){
                        x.rootvm = self.rootvm
                        return new AdminEvent(x);
                    }));

                //console.log(data.total_count);

                self.total_count(data.total_count);
                self.filtered_count(data.total_count);
                self.last_week_count(data.last_week);
            },
            error: function (data) {
                notyf.error(data.statusText);
            },
            complete: function(){
                self.rootvm.is_busy(false);
            }
        });
    };

    // Everything below is for paging -- should really create a
    // component at some point

    self.lower_count_label = ko.computed(function(){
        return parseInt(self.offset()) + 1;
    });

    self.upper_count_label = ko.computed(function(){
        if (parseInt(self.limit()) + parseInt(self.offset()) > self.filtered_count())
        {
            return self.filtered_count();
        }
        else
        {
            return parseInt(self.limit()) + parseInt(self.offset());
        }
    });



    self.paging_visible = ko.computed(function () {
        return self.total_count() > 0;
    });

    self.next_button_visible = ko.computed(function() {
        return parseInt(self.offset()) + parseInt(self.limit()) < self.filtered_count();
    });

    self.previous_button_visible = ko.computed(function () {
        return parseInt(self.offset()) > 0;
    });



    self.go_left = function () {

        if (self.rootvm.is_busy()){
            return false;}

        self.offset(parseInt(self.offset()) - parseInt(self.limit()));

        self.lookup_past_events().then(function(){
            pager.navigate("#concerts/past"
                + "?offset="
                + self.offset()
                + "&limit="
                + self.limit()
            );
        });
    };

    self.go_right = function () {

        if (self.rootvm.is_busy()){
            return false;}

        self.offset(parseInt(self.offset()) + parseInt(self.limit()));
        self.lookup_past_events().then(function(){
            pager.navigate("#concerts/past"
                + "?offset="
                + self.offset()
                + "&limit="
                + self.limit()
            );
           });
    };
};
